(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/top-bar/top-bar-overlay.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/top-bar/top-bar-overlay.js');
"use strict";

const {
  useEffect,
  useRef,
  useState
} = React;
const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const Icon = svs.ui.ReactIcon;
setGlobal('svs.ticketgames.ticketUtility.components.TopBarOverlay', _ref => {
  var _ticketInfo$gameGuide;
  let {
    isActive = false,
    onCloseOverlay,
    guides,
    trackingLabel
  } = _ref;
  const {
    ticketInfo
  } = svs.ticketgames.ticketUtility.components.useGameContext();
  const {
    trackTopBarAction
  } = svs.ticketgames.ticketUtility.utils.tracking;
  const OverlayPage = svs.ticketgames.ticketUtility.components.OverlayPage;
  const overlayRef = useRef(null);
  const mounted = useRef(false);
  const [activeTab, setActiveTabState] = useState('');
  const setActiveTab = tabName => {
    setActiveTabState(tabName);
    if (isActive && tabName) {
      trackTopBarAction("flik-".concat(tabName.toLowerCase()), trackingLabel);
    }
  };
  const [shouldCloseOverlay, setShouldCloseOverlay] = useState(false);
  if (!(ticketInfo !== null && ticketInfo !== void 0 && (_ticketInfo$gameGuide = ticketInfo.gameGuide) !== null && _ticketInfo$gameGuide !== void 0 && _ticketInfo$gameGuide.guides.length) > 0) {
    return null;
  }
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  useEffect(() => {
    (guides === null || guides === void 0 ? void 0 : guides.length) > 0 && isActive && setActiveTab(activeTab || guides[0].tabName);
  }, [guides, isActive]);
  useEffect(() => {
    if (!isActive) {
      return;
    }
    if (!shouldCloseOverlay) {
      gsap.to(overlayRef.current, {
        x: 0,
        duration: 0.5,
        onComplete: () => {
          const activeTabElement = document.querySelector('.ts-top-bar-tab-active');
          activeTabElement === null || activeTabElement === void 0 || activeTabElement.focus();
        }
      });
    } else {
      gsap.to(overlayRef.current, {
        x: '100%',
        duration: 0.5,
        onComplete: () => {
          if (mounted.current) {
            onCloseOverlay();
            setShouldCloseOverlay(false);
          }
        }
      });
    }
  }, [isActive, shouldCloseOverlay]);
  if (!isActive) {
    return null;
  }
  return React.createElement("div", {
    className: "top-bar-overlay padding-bottom-2",
    ref: overlayRef,
    style: {
      transform: 'translateX(100%)'
    }
  }, React.createElement("div", {
    className: "bg-navy ts-top-bar-game-info"
  }, React.createElement(ItemsMenu, {
    branding: "tur",
    inverted: true
  }, React.createElement("a", {
    "aria-label": "St\xE4ng spelinformation",
    className: "ts-top-bar-tab margin-top-half padding-1",
    href: "",
    onClick: e => {
      e === null || e === void 0 || e.preventDefault();
      setShouldCloseOverlay(true);
    },
    tabIndex: isActive ? 0 : -1
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "menu-left"
  })), guides.map((_ref2, i) => {
    let {
      tabName
    } = _ref2;
    return React.createElement(LinkItem, {
      className: "fc-white ts-top-bar-tab ".concat(activeTab === tabName && 'ts-top-bar-tab-active'),
      Component: "a",
      href: "",
      key: "".concat(tabName + i),
      label: tabName,
      onClick: e => {
        e.preventDefault();
        setActiveTab(tabName);
      },
      selected: activeTab === tabName,
      tabIndex: isActive ? 0 : -1
    });
  }))), React.createElement(OverlayPage, {
    guide: guides.find(_ref3 => {
      let {
        tabName
      } = _ref3;
      return tabName === activeTab;
    })
  }));
});

 })(window);